import React from 'react';
import { Box, Plug } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { parseSafeNumber } from '../../utils/helpers';

export const EquipmentCards: React.FC = () => {
  const { equipmentItems, highlightItem, setActiveView } = useApp();

  const newEquipment = equipmentItems.filter((item) => item['Status']?.includes('N'));

  if (newEquipment.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <h2 className="section-title" style={{ margin: 0 }}>
          <Box className="h-5 w-5 text-amber-500" />
          <span>New Equipment Items</span>
        </h2>
        <button
          type="button"
          className="btn-action"
          style={{ fontSize: '0.82rem', padding: '6px 12px' }}
          onClick={() => setActiveView('MATERIAL_LIST')}
        >
          <span>View in Material BOM &rarr;</span>
        </button>
      </div>

      <div className="equipment-cards-grid">
        {newEquipment.map((item, idx) => {
          const description = item['Description'] || 'None';
          const enclosure = item['Enclosure'] || 'None';
          const equipment = item['Equipment'] || 'None';
          const quantity = parseSafeNumber(item['Quantity']) || 1;
          const rating = item['Rating'] || 'N/A';
          const voltage = item['Voltage'] || 'N/A';
          const type = item['Type'] || 'N/A';

          return (
            <div
              key={idx}
              className="equipment-card"
              onClick={() => highlightItem(item['_bbox'])}
            >
              <div className="eq-header">
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '36px',
                    height: '36px',
                    background: 'rgba(245, 127, 23, 0.1)',
                    color: 'var(--primary)',
                    borderRadius: '8px',
                  }}
                >
                  <Plug className="h-5 w-5" />
                </span>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h4 style={{ margin: 0, fontSize: '1rem', fontWeight: 700 }}>{equipment}</h4>
                  <span className="eq-badge">NEW</span>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)', lineHeight: 1.4 }}>
                  {description}
                </div>
                <div className="eq-details-grid">
                  <div className="eq-detail">
                    <span style={{ color: 'var(--text-muted)' }}>Qty:</span>
                    <strong>{quantity}</strong>
                  </div>
                  <div className="eq-detail">
                    <span style={{ color: 'var(--text-muted)' }}>Type:</span>
                    <strong>{type}</strong>
                  </div>
                  <div className="eq-detail">
                    <span style={{ color: 'var(--text-muted)' }}>Rating:</span>
                    <strong>{rating}</strong>
                  </div>
                  <div className="eq-detail">
                    <span style={{ color: 'var(--text-muted)' }}>Voltage:</span>
                    <strong>{voltage}</strong>
                  </div>
                  <div className="eq-detail">
                    <span style={{ color: 'var(--text-muted)' }}>Enclosure:</span>
                    <strong>{enclosure}</strong>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
